export const EXTERNAL_LINKS = {
  FAQ: "https://help.enko.kr/articles/housing/faq",
  HOST_HELP_CENTER: "https://host-support.enko.kr",
  HOST_HELP_CENTER_KO: "https://host-support.enko.kr/hc/ko-kr",
  HOST_GUIDE_BOOK:
    "https://host-support.enko.kr/hc/ko-kr/articles/16206944848527-%EC%8B%A0%EA%B7%9C-%ED%98%B8%EC%8A%A4%ED%8A%B8%EB%8B%98%EC%9D%84-%EC%9C%84%ED%95%9C-%EC%97%94%EC%BD%94%EC%8A%A4%ED%85%8C%EC%9D%B4-%ED%98%B8%EC%8A%A4%ED%8A%B8-%EA%B0%80%EC%9D%B4%EB%93%9C%EB%B6%81",
  HOST_LANDING: "https://host.enko.kr/intro",
  FIP: "https://www.letsfip.com?utm_source=enkorstay&utm_medium=main&utm_campaign=shortcut",
  ENKOR_ABOUT_US: "https://enkor.career.greetinghr.com/ko/about",
  ENKOR_CAREERS:
    "https://enkor.career.greetinghr.com/ko/main#464459ac-cbdf-4b31-a8db-2e83eb33d2d2",
  ENKOR_CULTURE: "https://enkor.career.greetinghr.com/culture",
  HOST_FORM_LINK: "https://forms.gle/YbrkbYVneCqFfmUa7",
  STAY_HELP_CENTER: "https://stay-support.enko.kr",
  STAY_HELP_CENTER_EN: "https://stay-support.enko.kr/hc/en-us",
  SUPPORT_CENTER_NOTION_LINK:
    "https://enkorwithus.notion.site/1a1d9e29823480bc8a4fc8b927125cd9",
  PARTNER_FORM_LINK:
    "https://enkorwithus.notion.site/1bbd9e29823481379be7df8492149e31?pvs=105",
  STAY_SUPPORT_ISSUE_SUBMIT:
    "https://stay-support.enko.kr/hc/en-us/requests/new",
  STAY_BENEFITS_PROGRAM_POLICY:
    "https://stay-support.enko.kr/hc/en-us/articles/17118773451535--Enkostay-Benefits-Program-Policy-v1-0",
  HOST_SPACE_USAGE_CHANGE_FORM:
    "https://docs.google.com/forms/d/e/1FAIpQLSdpEShqBAJf2mb-CuknNQpaYNWe_eicQaGkGBuwKYY_wlnS0Q/viewform?usp=preview",
} as const;

export const CONTACT_INFO = {
  HELP_CENTER_PHONE: "1533-9230",
} as const;

export const ARC_KAKAOTALK_CHANNEL_LINK = "http://pf.kakao.com/_zMZrG" as const;
export const STAY_CHANNEL_IO_LINK = "https://stay-enkor.channel.io/" as const;
export const HOST_KAKAOTALK_CHANNEL_LINK =
  "http://pf.kakao.com/_blGEn/chat" as const;

export const BEDDING_LINKS = {
  FAQ: "https://help.enko.kr/articles/bedding/extension",
} as const;

export const SOCIAL_LINKS = {
  ENKOR_STAY: "https://stay.enko.kr/",
  ENKOR_HOST: "https://host.enko.kr/",
  ENKOR_BLOG: "https://stay.enko.kr/blog",
  INSTAGRAM_STAY: "https://www.instagram.com/enkostay_korea/",
  FIP: "https://www.letsfip.com",
  INSTAGRAM_FIP: "https://www.instagram.com/enkoplay_community",
  TIKTOK: "https://www.tiktok.com/@letsfip_",
  COMPANY_LINKEDIN: "https://www.linkedin.com/company/enjoykoreawithus",
  STAY_YOUTUBE_MAIN: "https://www.youtube.com/@Enkostay",
  HOST_YOUTUBE_MAIN: "https://www.youtube.com/@EnkostayHostOfficial",
  STAY_YOUTUBE_SHORTS: "https://www.youtube.com/@Enkostay/shorts",
} as const;

export const STAY_BLOG_ARTICLE_LINKS = {
  NO_DEPOSIT:
    "https://stay.enko.kr/blog/en/seoul-student-apartments-without-key-money-no-deposit-options/",
  IS_ENKOSTAY_LEGIT:
    "https://stay.enko.kr/blog/en/is-enkostay-legit-what-you-should-know-before-booking-housing-in-seoul/",
  RESIDENCE_CARD_GUIDE:
    "https://stay.enko.kr/blog/en/how-to-get-your-residence-card-in-korea-2025-guide/",
} as const;

export const LEGAL_DOCUMENT_LINKS = {
  TERMS_OF_CONDITIONS: {
    en: "https://stay-support.enko.kr/hc/en-us/articles/15799559805711--Terms-of-Service-v1-0",
    ko: "https://stay-support.enko.kr/hc/en-us/articles/15799531678351--%EC%9D%B4%EC%9A%A9%EC%95%BD%EA%B4%80-v1-0",
  },
  CANCELLATION_AND_REFUND_POLICY: {
    en: "https://stay-support.enko.kr/hc/en-us/articles/14655543402767--Tenant-Policy-v2-1#article-24.-contract-cancellation-(before-move-in)",
    ko: "https://stay-support.enko.kr/hc/en-us/articles/15799533758095--%EC%84%B8%EC%9E%85%EC%9E%90-%EA%B7%9C%EC%A0%95-v2-1#%EC%A0%9C24%EC%A1%B0-%EA%B3%84%EC%95%BD%EC%9D%98-%EC%B7%A8%EC%86%8C-(%EC%9E%85%EC%8B%A4-%EC%A0%84)",
  },
  TENANT_POLICY: {
    en: "https://stay-support.enko.kr/hc/en-us/articles/14655543402767--Tenant-Policy-v2-1",
    ko: "https://stay-support.enko.kr/hc/en-us/articles/15799533758095--%EC%84%B8%EC%9E%85%EC%9E%90-%EA%B7%9C%EC%A0%95-v2-1",
  },
  PRIVACY_POLICY: {
    en: "https://stay-support.enko.kr/hc/en-us/articles/15799575254671--Privacy-Policy",
    ko: "https://stay-support.enko.kr/hc/en-us/articles/15799540188815--%EA%B0%9C%EC%9D%B8%EC%A0%95%EB%B3%B4-%EC%B2%98%EB%A6%AC%EB%B0%A9%EC%B9%A8",
  },
  HOST_TERMS_OF_CONDITIONS: {
    en: "https://host-support.enko.kr/hc/ko-kr/articles/14655885073551-%ED%98%B8%EC%8A%A4%ED%8A%B8-%EC%95%BD%EA%B4%80-%EB%B0%8F-%EA%B7%9C%EC%A0%95-v1-1",
    ko: "https://host-support.enko.kr/hc/ko-kr/articles/14655885073551-%ED%98%B8%EC%8A%A4%ED%8A%B8-%EC%95%BD%EA%B4%80-%EB%B0%8F-%EA%B7%9C%EC%A0%95-v1-1",
  },
  HOST_PRIVACY_POLICY: {
    en: "https://host-support.enko.kr/hc/ko-kr/articles/15799505406607-%EA%B0%9C%EC%9D%B8%EC%A0%95%EB%B3%B4-%EC%B2%98%EB%A6%AC%EB%B0%A9%EC%B9%A8",
    ko: "https://host-support.enko.kr/hc/ko-kr/articles/15799505406607-%EA%B0%9C%EC%9D%B8%EC%A0%95%EB%B3%B4-%EC%B2%98%EB%A6%AC%EB%B0%A9%EC%B9%A8",
  },
} as const;

export const ARC_LEGAL_DOCUMENT_LINKS = {
  FAQ: {
    en: "https://help.enko.kr/articles/category/english/",
    ko: "https://help.enko.kr/articles/category/korean/",
  },
  POLICY: {
    en: "https://help.enko.kr/policies/arc/privacy_policy_en",
    ko: "https://help.enko.kr/policies/arc/privacy_policy_kr",
  },
  TERMS_OF_SERVICE: {
    en: "https://help.enko.kr/policies/arc/terms_of_service_en",
    ko: "https://help.enko.kr/policies/arc/terms_of_service_kr",
  },
  REFUND: {
    en: "https://help.enko.kr/policies/arc/refund_policy",
    ko: "https://help.enko.kr/policies/arc/refund_policy",
  },
  HELP_CENTER: {
    en: "https://help.enko.kr/articles/visa/en/quickstart",
    ko: "https://help.enko.kr/articles/visa/ko/quickstart",
  },
} as const;

export const LETSFIP_LEGAL_DOCUMENT_LINKS = {
  TERMS_OF_CONDITIONS: {
    en: "https://help.enko.kr/policies/letsfip/terms_of_service_en",
    ko: "https://help.enko.kr/policies/letsfip/terms_of_service_kr",
  },

  PRIVACY_POLICY: {
    en: "https://help.enko.kr/policies/letsfip/privacy_policy_en",
    ko: "https://help.enko.kr/policies/letsfip/privacy_policy_kr",
  },
} as const;

export const LETSFIP_APP_STORE_LINK = {
  ANDROID:
    "https://play.google.com/store/apps/details?id=com.letsfip.pilot&referrer=utm_source%3Dletsfip%26utm_medium%3Dappdownload%26utm_campaign%3Dlaunch%26anid%3Dadmob",
  IOS: "itms-apps://itunes.apple.com/app/id6497171060?pt=letsfip&ct=appdownload&mt=8",
} as const;

export const ENKO_PICK_URL = {
  ROOM_TOUR:
    "https://www.notion.so/enkorwithus/1e4d9e298234809c9df1f471c7b71197?pvs=106",
} as const;

export const ENKO_NOTION_DATABASE_LINK = {
  HOST_FAQ:
    "https://enkorwithus.notion.site/20fd9e298234805bb294f8a916acd874?v=20fd9e29823480f1be82000c1980ef67",
} as const;

export const STAY_APP_STORE_LINK = {
  ANDROID: "https://play.google.com/store/apps/details?id=com.stay.pilot",
  IOS: "https://apps.apple.com/app/enkostay/id6737757796",
} as const;

export const BEDDING_OPERATOR_CONTACT_LINK =
  "https://kny25.channel.io/home" as const;
